import React from "react";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

import { Link } from "react-router-dom";
import { useModelIndex } from "@rhino-project/core/hooks";

export default function DualUseOnRamp() {
  useModelIndex("submission" as any, { limit: 1 } as any);
  return (
    <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
          <section className="w-full space-y-6">
      <Card className="border-primary/20 shadow-sm">
      <CardHeader>
      <Badge className="w-fit">Dual-Use On-Ramp</Badge>
      <CardTitle className="text-2xl">Start from what your solution already does</CardTitle>
      <CardDescription>Describe your capability in commercial language and receive defence-ready framing, triage, and routing guidance.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-3">
      <Button asChild><Link to="/dual-use-on-ramp/intake">Start Intake</Link></Button>
      <Button asChild variant="outline"><Link to="/dual-use-on-ramp/translation">Run Capability Translation</Link></Button>
      </CardContent>
      </Card>

      <div className="grid gap-4 md:grid-cols-2">
      {[
      "Signal capture",
      "Capability translation",
      "Readiness and clearance sequencing",
      "Routing and navigator handoff",
      ].map((step, index) => (
      <Card key={step} className="border-border shadow-sm">
      <CardHeader>
      <CardTitle className="text-base">Step {index + 1}</CardTitle>
      <CardDescription>{step}</CardDescription>
      </CardHeader>
      </Card>
      ))}
      </div>

      <Card className="border-border bg-muted/40 shadow-sm">
      <CardContent className="flex flex-wrap items-center justify-between gap-3 p-5">
      <p className="text-sm text-muted-foreground">Continue your journey through submissions tracking and readiness routing.</p>
      <div className="flex flex-wrap gap-3">
      <Button asChild variant="secondary"><Link to="/dual-use-on-ramp/my-submissions">My Submissions</Link></Button>
      <Button asChild variant="outline"><Link to="/dual-use-on-ramp/readiness-routing">Readiness &amp; Routing</Link></Button>
      </div>
      </CardContent>
      </Card>
      </section>
      </div>
    </div>
  );
}